import { inject } from "fw";
import { createFrom, createFromArray } from "fw-model";

import { Manager } from "./manager";
import { AtsOrganizationSearchResult, AtsOrganizationSummary } from "models/ats-organization-summary";
import { ImportTaskSearchResult } from "../models/monitor-application-imports";
import { SearchResult } from "models/search-result";

@inject
export class AtsOrgSummaryRepository {
    constructor(private s: Manager) {}

    async search(
        f: string = null,
        s: string = null,
        sort: string = null,
        page = 1,
        pageSize = 20,
        searchBeforeToken: string = null,
        searchAfterToken: string = null,
        fieldPaths: string = null
    ) {
        const res = await this.s.get<AtsOrganizationSearchResult>("ats-org-summary", {
            page,
            pageSize,
            searchBeforeToken,
            searchAfterToken,
            fieldPaths,
            f,
            s,
            sort
        });
        const results = createFrom(AtsOrganizationSearchResult, res.body);
        return {
            total: results.Total,
            list: results.Results
        };
    }

    async getTags() {
        const res = await this.s.get<AtsOrganizationSearchResult>("ats-org-summary", { aggs: "terms:tags~1000", countsOnly: "true" });

        return res.body?.Aggregations?.terms_tags?.Items?.map((tag) => tag.Key);
    }

    async getOrgsOfType(type: number) {
        const res = await this.s.get<AtsOrganizationSearchResult>("ats-org-summary", {
            f: `metaData.type:${type}`,
            aggs: "terms:id~1000",
            countsOnly: "true"
        });

        return res.body?.Aggregations?.terms_id?.Items?.map((id) => id.Key);
    }

    async getOrgsWithTags(tags: string[]) {
        const tagFilters = tags.map((tag) => `tags:("${tag}")`).join(" AND ");
        const res = await this.s.get<AtsOrganizationSearchResult>("ats-org-summary", {
            f: tagFilters,
            aggs: "terms:id~1000",
            countsOnly: "true"
        });

        return res.body?.Aggregations?.terms_id?.Items?.map((id) => id.Key);
    }

    async searchWithMappings(
        errors: boolean = false,
        f: string = null,
        s: string = null,
        sort: string = null,
        page = 1,
        pageSize = 20,
        searchBeforeToken: string = null,
        searchAfterToken: string = null,
        fieldPaths: string = null
    ) {
        const res = await this.s.get<any[]>("ats-org-summary/with-mappings", {
            errors,
            page,
            pageSize,
            searchBeforeToken,
            searchAfterToken,
            fieldPaths,
            f,
            s,
            sort
        });
        const results = createFromArray(AtsOrganizationSummary, res.body);
        return {
            total: parseInt(res.headers["x-manager-total"], 10),
            list: results
        };
    }
}
